import React from 'react';
import './App.css';
import { Link, Routes, Route } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Home from './pages/Home/Home';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Courses from './pages/Courses/Courses';
import About from './pages/About/About';
import Report from './pages/Reports/Report';
import Contact from './pages/Contact/Contact';
import Blog3Img from './utils/images/LeadsQLogo.png';
import Footer from './components/Footer/Footer';
import AppNavbar from './components/AppNavbar/AppNavbar';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';


function App() {
  const reports = [
    { id: 1, name: 'CHEMICALS AND MATERIALS' },
    { id: 2, name: 'ENERGY AND POWER' },
    { id: 3, name: 'FOOD AND BEVERAGES' },
    { id: 4, name: 'AUTOMOTIVE' },
    { id: 5, name: 'OTHERS' }
  ];
  return (
    <div>
      <ScrollToTop />
      <AppNavbar></AppNavbar>

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/courses' element={<Courses />} />
        <Route path='/about' element={<About />} />
        {/* <Route path='/blog' element={<Blog />} /> */}
        <Route path='/contact' element={<Contact />} />
        <Route path="/report/:reportId" element={<Report />} />
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
